import { BaseController } from './BaseController'

export class AuthorizationController extends BaseController {
  async isAuthorized (): Promise<any> {
    return await this.getLDAPAuth()
  }
}
